<template>
  <v-btn
    color="#FFFFFF"
    @click="clickAction"
    block
    class="font-weight-bold normal_simple_solid_button"
    elevation="0"
    height="44px"
  >
    <p>{{ buttonTitle }}</p>
  </v-btn>
</template>

<script>
export default {
  name: "NormalSimpleSolidButton",
  data: () => ({}),
  methods: {
    clickAction() {
      this.$emit("clickAction");
    }
  },
  components: {},
  props: ["buttonTitle"]
};
</script>

<style scoped>
.normal_simple_solid_button {
  border-radius: 22px;
  border-width: 1px;
  border-style: solid;
  border-color: #000000 !important;
}
p {
  margin: 0;
  color: #000;
  font-weight: bold;
}
</style>
